import { render, staticRenderFns } from "./CrudComponent.vue?vue&type=template&id=796158ee&scoped=true&"
import script from "./CrudComponent.vue?vue&type=script&lang=js&"
export * from "./CrudComponent.vue?vue&type=script&lang=js&"
import style0 from "./CrudComponent.vue?vue&type=style&index=0&id=796158ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796158ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VCombobox,VContainer,VForm,VImg,VRow})
